<template>
  <div class="manage-content">
    <div class="location">企业管理中心 / 我的推广</div>
    <div class="white-bg shadow margin-top-20 padding30 radius">
      <el-tabs v-model="activeType" @tab-click="handleClick">
        <el-tab-pane label="待付款" name="3">
          <tab4  :list="list"
                 :orderTotal="orderTotal"
                 :currentPage="currentPage"
                 @func="cancel"
                 @changcurrent='changPage'
                 ></tab4>
        </el-tab-pane>
        <el-tab-pane label="进行中" name="1" >
          <tab1 :list="list"
                :orderTotal="orderTotal"
                :currentPage="currentPage"
                @func="cancel"
                @changcurrent='changPage'
          ></tab1>
        </el-tab-pane>
        <el-tab-pane label="待审核" name="0">
          <tab2 :list="list"
                :orderTotal="orderTotal"
                :currentPage="currentPage"
                @func="cancel"
                @changcurrent='changPage'
          ></tab2>
        </el-tab-pane>
        <el-tab-pane label="已结束" name="2">
          <tab3 :list="list"
                :orderTotal="orderTotal"
                :currentPage="currentPage"
                @changcurrent='changPage'
               ></tab3>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import {orderList,taskCancel} from '@/config/api.js'
import Tab1 from './components/Tab1'
import Tab2 from './components/Tab2'
import Tab3 from './components/Tab3'
import Tab4 from './components/Tab4'
export default {
  name: 'EnterpriseOrder',
  inject:['reload'],
  provide(){
    return{
      getOrder:this.getOrder,
    }
  },
  components: {Tab1, Tab2, Tab3,Tab4},
  data () {
    return {
      activeType: String(this.$store.state.epOrderTab),
      list: [],
      orderTotal: 0,
      currentPage:1,
    }
  },
  methods: {
    changPage(val){
      this.currentPage = val;
    },
    handleClick (tab) {
      this.getOrder();
      this.$store.commit('changeEpOrderTab',tab.paneName);
    },
    getOrder () {
      let data = {
        user_type: this.$store.state.user_type,
        // page
        page: this.currentPage -1,
        user_id: this.$store.state.user_id,
        type: this.activeType
      };
      // console.log(data)
      this.$post(orderList,data)
              .then(res => {
                // console.log(res.data.user_type)
                const data = res.data;
                this.list = data.list;
                this.orderTotal = Number(data.count);
                // console.log(this.currentPage,'+++=')
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    cancel (id) {
      this.$confirm('确认要取消该任务吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          user_type: this.$store.state.user_type,
          task_id: id,
          user_id: this.$store.state.user_id,
        };
        this.$post(taskCancel,data)
                .then(res => {
                  this.$message.success(res.msg);
                  this.reload()
                })
                .catch(err => {
                  this.$message.error(err.msg)
                })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    }
  },
  computed: {
    listCon () {
      return this.list
    }
  },
  watch: {
    list (val) {
      this.list = val
    }
  },
  created() {
    this.getOrder();
  }
}
</script>
<style scoped></style>
